const products = [
 {
  id: "1",
  slug: "black-cup-masturbator-for-men",
  name: "Black Cup Masturbator for Men",
  image: "/image/ForMen/ForMen1.jpg",
  price: "1699",
  mrp: "2999",
  category: "men",
  description:
    "Buy Black Cup Masturbator for men in India, designed to deliver a realistic and intense pleasure experience. This premium masturbator features a soft, skin-friendly inner texture that closely mimics natural sensations, making it ideal for solo pleasure and stress relief.\n\nMade from high-quality, body-safe silicone material, the Black Cup Masturbator is comfortable to use, durable, and easy to clean. Its compact and lightweight design allows for convenient storage and travel, while the firm outer grip ensures better control during use.\n\nPerfect for beginners as well as experienced users, this men pleasure toy helps enhance stamina, improve performance, and explore personal pleasure in a safe and hygienic way.\n\nOrder the Black Cup Masturbator online from LushDesire with 100% discreet packaging, secure payment options, and fast delivery across India. Trusted adult store for premium men pleasure products."
},

 {
  id: "2",
  slug: "pocket-pussy-jumbo",
  name: "Pocket Pussy Jumbo ",
  image: "/image/ForMen/ForMen2.jpg",
  price: "1999",
  mrp: "2999",
  category: "men",
  description: `Pocket Pussy Jumbo is a premium-quality personal wellness product designed to provide a realistic and comfortable experience. Made from soft, skin-friendly material, it ensures a natural touch and smooth feel for enhanced satisfaction.

Premium fleshlight-style masturbator for men in India. Realistic texture, durable build & privacy-first shipping.

This product is lightweight, portable, and easy to use. It offers a jumbo size design for better grip and enhanced usability. The reusable build ensures long-term use and easy cleaning, making it hygienic and durable.

It comes with 100% discreet packaging and safe delivery across India. Cash on Delivery (COD) is also available for convenience.

    Pocket Pussy Jumbo एक प्रीमियम-क्वालिटी वाला पर्सनल वेलनेस प्रोडक्ट है, जिसे एक असली जैसा और आरामदायक अनुभव देने के लिए डिज़ाइन किया गया है। मुलायम, त्वचा के अनुकूल मटीरियल से बना यह प्रोडक्ट, ज़्यादा संतुष्टि के लिए एक प्राकृतिक स्पर्श और चिकना एहसास देता है।

भारत में पुरुषों के लिए प्रीमियम फ्लेशलाइट-स्टाइल मास्टरबेटर। असली जैसी बनावट, मज़बूत बनावट और पूरी तरह से गोपनीय शिपिंग।

यह प्रोडक्ट हल्का, कहीं भी ले जाने लायक और इस्तेमाल में आसान है। बेहतर पकड़ और ज़्यादा आसानी से इस्तेमाल करने के लिए इसका डिज़ाइन जंबो साइज़ का है। इसे बार-बार इस्तेमाल किया जा सकता है और इसकी सफ़ाई भी आसान है, जिससे यह साफ़-सुथरा और टिकाऊ बना रहता है।

यह 100% गोपनीय पैकेजिंग और पूरे भारत में सुरक्षित डिलीवरी के साथ आता है। आपकी सुविधा के लिए कैश ऑन डिलीवरी (COD) की सुविधा भी उपलब्ध है।
`
,
},
{
  id: "3",
  slug: "pocket-pussy-for-men-india",
  name: "Pocket Pussy For Men",
  image: "/image/ForMen/ForMen3.jpg",
  price: "1599",
  mrp: "3000",
  category: "men",
  description:
    "Buy Pocket Pussy for men in India designed for a smooth, comfortable, and realistic pleasure experience. Made from premium soft silicone material, this pocket masturbator offers a skin-friendly texture that feels natural and gentle during use.\n\nIts compact and lightweight design makes it easy to carry and store discreetly, ideal for private use at home or while traveling. The firm outer grip provides better control, while the inner sleeve enhances sensation and comfort.\n\nPerfect for beginners as well as experienced users, this pocket pussy helps relieve stress, improve stamina, and explore personal pleasure safely. Order online from LushDesire with 100% discreet packaging, secure payments, and fast delivery across India."
},
{
  id: "4",
  slug: "mia-cup-masturbator-for-men",
  name: "Mia Cup Masturbator",
  image: "/image/ForMen/ForMen4.jpg",
  price: "2199",
  mrp: "2499",
  category: "men",
  description:
    "The Mia Cup Masturbator for men is specially designed to deliver intense yet comfortable pleasure. Featuring an advanced cup-style structure with enhanced inner texture, it provides a realistic sensation while maintaining full control and ease of use.\n\nCrafted from body-safe, high-quality silicone, this masturbator is soft, durable, and easy to clean. Its ergonomic design ensures a secure grip, making it suitable for regular use without discomfort.\n\nIdeal for men looking to enhance solo pleasure and relaxation, the Mia Cup Masturbator is discreet, portable, and hygienic. Buy online from LushDesire with discreet packaging and fast delivery anywhere in India."
},
{
  id: "5",
  slug: "mini-cup-masturbator-for-men",
  name: "Mini Cup Masturbator for Men",
  image: "/image/ForMen/ForMen5.jpg",
  price: "1999",
  mrp: "2499",
  category: "men",
  description: `Mini Cup Masturbator for Men is a compact and affordable personal wellness product designed for beginners as well as regular users. Made with soft, flexible, and body-safe material, it offers a smooth and comfortable experience without being overwhelming.

Its lightweight and portable design makes it easy to handle, store, and carry during travel. Despite its mini size, the inner sleeve is crafted to provide controlled and comfortable stimulation, making it suitable for everyday use.

This product is reusable and easy to clean, ensuring proper hygiene and long-term durability. It is an ideal choice for those looking for a simple, reliable, and budget-friendly personal care solution.

It comes with 100% discreet packaging and secure delivery across India. Cash on Delivery (COD) is also available for complete privacy and convenience.

Order now from LushDesire for a safe, private, and user-friendly experience.`,
},
{
  id: "6",
  slug: "torch-shape-black-masturbator-for-men",
  name: "Torch Shape Black Masturbator",
  image: "/image/ForMen/ForMen6.jpg",
  price: "2650",
  mrp: "2799",
  category: "men",
  description:
    "The Torch Shape Black Masturbator for men is designed for a premium and realistic pleasure experience. Its torch-style body offers a strong grip, while the detailed inner design enhances sensation and comfort.\n\nMade from high-quality, body-safe silicone, this masturbator is durable, hygienic, and easy to maintain. The sleek black design ensures discretion, while the ergonomic shape allows better control during use.\n\nIdeal for men seeking advanced pleasure products, this masturbator is perfect for private relaxation and stress relief. Buy online from LushDesire with discreet packaging and fast delivery across India."
},

{
  id: "7",
  slug: "mini-sex-doll-for-men-india",
  name: "Mini Sex Doll",
  image: "/image/ForMen/ForMen7.jpg",
  price: "2999",
  mrp: "3999",
  category: "men",
  description:
    "Buy Mini Sex Doll for men in India designed for comfort, realism, and discreet use. Made with soft-touch, skin-friendly material, this compact doll offers a natural feel while remaining easy to handle.\n\nIts lightweight and space-saving design makes it ideal for private use and convenient storage. Suitable for beginners and experienced users.\n\nOrder online from LushDesire with 100% discreet packaging and fast delivery across India."
},
{
  id: "8",
  slug: "realistic-doggy-style-sex-doll-for-men",
  name: "Realistic Doggy Style Sex Doll",
  image: "/image/ForMen/ForMen8.jpg",
  price: "5999",
  mrp: "6499",
  category: "men",
  description:
    "Realistic Doggy Style Sex Doll for men crafted to deliver a lifelike and immersive experience. Designed with natural body posture and detailed finishing for enhanced realism.\n\nMade from premium, body-safe material, it is durable, comfortable, and easy to maintain for regular private use.\n\nBuy online from LushDesire with discreet delivery across India."
},
{
  id: "9",
  slug: "2-in-1-masturbator-for-men",
  name: "2 in 1 Masturbator",
  image: "/image/ForMen/ForMen9.jpg",
  price: "2999",
  mrp: "3899",
  category: "men",
  description:
    "2 in 1 Masturbator for men designed to provide dual-function pleasure in a single device. Crafted from body-safe silicone for a realistic and comfortable experience.\n\nEasy to clean, lightweight, and discreet to store, making it suitable for daily use.\n\nAvailable at LushDesire with private packaging and fast delivery in India."
},
{
  id: "10",
  slug: "automatic-masturbation-cup-india",
  name: "automatic-masturbation-cup-india",
  image: "/image/ForMen/ForMen10.jpg",
  price: "11999",
  mrp: "16000",
  category: "men",
  description: `Fully Automatic Rotating Masturbation Cup is a premium personal wellness product designed to deliver a hands-free and comfortable experience. Built with high-quality, body-safe materials, it ensures a smooth, skin-friendly feel while maintaining durability for long-term use.

This advanced device features an automatic rotating mechanism along with dual stimulation design, providing consistent motion and enhanced experience without manual effort. Its ergonomic design ensures secure handling, suitable for both beginners and experienced users.

The product is lightweight, portable, and easy to clean, ensuring proper hygiene and convenience. Multiple vibration modes allow users to customize their experience as per preference.

Designed with privacy in mind, it comes with 100% discreet packaging and secure delivery across India. Cash on Delivery (COD) is also available for added convenience.

Order online from LushDesire for a reliable, modern, and private personal care experience.`,
},
{
  id: "11",
  slug: "silicone-half-sex-doll-for-men",
  name: "Silicone Half Sex Doll",
  image: "/image/ForMen/ForMen11.jpg",
  price: "19999",
  mrp: "27999",
  category: "men",
  description:
    "Premium Silicone Half Sex Doll for men designed to deliver a realistic and luxurious experience. Made from high-grade silicone with lifelike texture and softness.\n\nIdeal for men looking for a long-term premium pleasure product.\n\nBuy online from LushDesire with privacy-first packaging and reliable delivery in India."
},
{
  id: "12",
  slug: "full-size-air-sex-doll-for-men",
  name: "Full Size Sex Doll (Air Doll)",
  image: "/image/ForMen/ForMen12.jpg",
  price: "18999",
  mrp: "18999",
  category: "men",
  description:
    "Full Size Air Sex Doll for men designed for easy usage, lightweight handling, and convenient storage. Inflatable design makes it practical for private use.\n\nSimple to maintain and store, suitable for discreet enjoyment.\n\nOrder online from LushDesire with safe and private delivery across India."
},
{
  id: "13",
  slug: "belt-condom-for-couples-india",
  name: "Belt Condom for Couples",
  image: "/image/ForMen/ForMen13.jpg",
  price: "2499",
  mrp: "7999",
  category: "men",
  description:
    "Adjustable Belt Condom for couples in India designed for secure fit, comfort, and confidence. Made with body-safe material ensuring reliability.\n\nIdeal for couples looking to enhance intimacy safely.\n\nAvailable at LushDesire with discreet packaging and trusted delivery."
},
{
  id: "14",
  slug: "couples-belt-condom-secure-fit",
  name: "Couples Belt Condom – Secure Fit",
  image: "/image/ForMen/ForMen14.jpg",
  price: "2499",
  mrp: "2299",
  category: "men",
  description:
    "Reusable Couples Belt Condom featuring strong grip and comfort-focused design. Built for durability and repeated use.\n\nA reliable option for couples seeking control and comfort.\n\nOrder online from LushDesire with private shipping across India."
},
{
  id: "15",
  slug: "premium-condoms-all-sizes-india",
  name: "Condoms – All Sizes Available",
  image: "/image/ForMen/ForMen15.jpg",
  price: "1210",
  mrp: "1999",
  category: "men",
  description:
    "Premium Condoms available in all sizes, designed for comfort, safety, and confidence. Tested for quality and reliability.\n\nPerfect for regular use with a comfortable fit.\n\nBuy online from LushDesire with discreet delivery in India."
},
{
  id: "16",
  slug: "soft-silicone-pleasure-toy-for-men",
  name: "Soft Silicone Toy",
  image: "/image/ForMen/ForMen16.jpg",
  price: "1499",
  mrp: "1999",
  category: "men",
  description:
    "Soft Silicone Pleasure Toy for men made from premium, body-safe silicone. Designed for smooth comfort and long-lasting use.\n\nEasy to clean, hygienic, and suitable for beginners as well as experienced users.\n\nAvailable at LushDesire with discreet packaging across India."
},
{
  id: "17",
  slug: "premium-condoms-for-men",
  name: "Premium Condoms",
  image: "/image/ForMen/ForMen17.jpg",
  price: "1899",
  mrp: "1999",
  category: "men",
  description:
    "High-quality Premium Condoms for men offering comfort, protection, and confidence. Manufactured under strict quality standards.\n\nIdeal for safe and reliable use.\n\nOrder online from LushDesire with discreet delivery."
},
{
  id: "18",
  slug: "vibrating-vagina-masturbator-for-men",
  name: "Vibrating Vagina Masturbator",
  image: "/image/ForMen/ForMen18.jpg",
  price: "3299",
  mrp: "3999",
  category: "men",
  description:
    "Vibrating Vagina Masturbator for men featuring a powerful yet silent motor for realistic sensation.\n\nCompact, body-safe, and travel-friendly design ensures comfort and discretion.\n\nBuy online from LushDesire with fast delivery across India."
},
{
  id: "19",
  slug: "advanced-vibrating-vagina-masturbator",
  name: "Vibrating Vagina Masturbator",
  image: "/image/ForMen/ForMen19.jpg",
  price: "3499",
  mrp: "6499",
  category: "men",
  description:
    "Advanced Vibrating Vagina Masturbator delivering premium comfort and enhanced pleasure with multiple vibration patterns.\n\nDurable, hygienic, and easy to maintain.\n\nAvailable online at LushDesire with discreet shipping in India."
},
{
  id: "20",
  slug: "7-mode-vibrating-masturbator-with-remote",
  name: "7 Mode Vibrating Masturbator with Remote Control",
  image: "/image/ForMen/ForMen20.jpg",
  price: "3999",
  mrp: "8999",
  category: "men",
  description:
    "7 Mode Vibrating Masturbator with Remote Control designed for hands-free comfort and customizable pleasure.\n\nBody-safe construction with ergonomic design for ease of use.\n\nOrder online from LushDesire with private delivery across India."
},
{
  id: "21",
  slug: "vibrating-masturbation-machine-for-men",
  name: "Vibrating Masturbation Machine for Men",
  image: "/image/ForMen/ForMen21.jpg",
  price: "9999",
  mrp: "12999",
  category: "men",
  description:
    "Powerful Vibrating Masturbation Machine for men featuring multiple modes and premium build quality.\n\nDesigned for advanced users seeking strong performance and durability.\n\nBuy from LushDesire with discreet delivery across India."
},
{
  id: "22",
  slug: "1-5-feet-realistic-pleasure-doll-for-men",
  name: "1.5 Feet Realistic Pleasure Doll for Men",
  image: "/image/ForMen/ForMen22.jpg",
  price: "14999",
  mrp: "19999",
  category: "men",
  description:
    "1.5 Feet Realistic Pleasure Doll for men made with premium, body-safe material. Compact yet highly detailed for realistic experience.\n\nIdeal for private use with easy handling and storage.\n\nAvailable at LushDesire with safe packaging and COD option in India."
},
{
  id: "23",
  slug: "vibrating-ring-for-men-india",
  name: "Vibrating Ring for Men",
  image: "/image/ForMen/ForMen23.jpg",
  price: "999",
  mrp: "1999",
  category: "men",
  description:
    "Vibrating Ring for men designed to enhance sensation with a comfortable and adjustable fit.\n\nLightweight, body-safe, and easy to use for regular pleasure.\n\nBuy online from LushDesire with discreet delivery across India."
},


{
  id: "24",
  slug: "realistic-solid-strap-on-dildo",
  name: "Realistic Solid Strap-On Dildo",
  image: "/image/ForMen/Formen24.jpg",
  price: "3999",
  mrp: "4999",
  category: "men",
  description: `Realistic Solid Strap-On Dildo is a premium personal wellness product designed for comfort, durability, and a natural feel. Made from high-quality, body-safe material, it offers a firm yet smooth texture for a reliable experience.

The realistic design enhances usability, while the solid build ensures better control and stability during use. It is suitable for both beginners and experienced users looking for a dependable and easy-to-use product.

This product is lightweight, easy to handle, and simple to clean, making it hygienic and reusable for long-term use. Its ergonomic design ensures convenience and comfort.

It comes with 100% discreet packaging and secure delivery across India. Cash on Delivery (COD) is also available for complete privacy and ease.

A great choice for those seeking a high-quality, durable, and private personal care product.`,
},

{
  id: "25",
  slug: "8-inch-realistic-dildo",
  name: "8 Inch Realistic Dildo",
  image: "/image/ForMen/ForMen25.jpg",
  price: "2999",
  mrp: "3499",
  category: "men",
  description: `8 Inch Realistic Dildo is a premium personal wellness product designed for a natural feel and comfortable experience. Made from soft, body-safe material, it provides a smooth and skin-friendly touch.

The realistic design enhances the overall experience, while the ergonomic shape ensures easy handling and convenience. It is suitable for both beginners and experienced users looking for a reliable and user-friendly option.

This product is lightweight, durable, and easy to clean, making it hygienic and reusable for long-term use. Its compact design allows for easy storage and portability.

It comes with 100% discreet packaging and secure delivery across India. Cash on Delivery (COD) is also available to ensure complete privacy and convenience.

A perfect choice for those seeking a high-quality, safe, and private personal care product.`,
},






  // products.js

/* ================= MEN PRODUCTS (existing) ================= */
// ⛔️ Yahan aapka menProducts jaisa ka taisa rahega
// const menProducts = [ ... ];

/* ================= WOMEN PRODUCTS (ADDED) ================= */

{
  id: "101",
  slug: "premium-dildo-for-women-india",
  name: "Premium Dildo for Pleasure",
  image: "/image/ForWomen/ForWomen1.jpg",
  price: "2500",
  mrp: "3200",
  category: "women",
  description:
    "Buy Premium Dildo for women in India designed for comfort, pleasure, and long-lasting use. Made with high-quality, body-safe material, this dildo offers a smooth texture and natural feel for a satisfying experience.\n\nIts ergonomic design makes it easy to use for beginners as well as experienced users. Durable, hygienic, and simple to clean for regular use.\n\nOrder online from LushDesire with 100% discreet packaging and fast delivery across India."
},
{
  id: "102",
  slug: "high-quality-silicone-dildo-for-women",
  name: "High-Quality Dildo",
  image: "/image/ForWomen/ForWomen2.jpg",
  price: "3399",
  mrp: "4200",
  category: "women",
  description:
    "High-Quality Silicone Dildo for women crafted to deliver a soft-touch and comfortable experience. Made from premium body-safe silicone for durability and safety.\n\nDesigned for smooth control and realistic pleasure, suitable for solo use or couple play.\n\nAvailable online at LushDesire with private packaging and discreet delivery in India."
},
{
  id: "103",
  slug: "premium-butt-plug-for-women-india",
  name: "Butt Plug",
  image: "/image/ForWomen/ForWomen3.jpg",
  price: "2299",
  mrp: "2600",
  category: "women",
  description:
    "Premium Butt Plug designed for comfort, safety, and confidence. Smooth finish with body-safe material ensures easy use and secure fit.\n\nIdeal for beginners and experienced users looking for a comfortable design.\n\nBuy online from LushDesire with discreet delivery across India."
},
{
  id: "104",
  slug: "adjustable-belt-dildo-for-couples-india",
  name: "Belt Dildo",
  image: "/image/ForWomen/ForWomen4.jpg",
  price: "3499",
  mrp: "3500",
  category: "women",
  description:
    "Adjustable Belt Dildo for couples in India designed for secure fit and comfortable performance. Made from body-safe material for safety and durability.\n\nEasy to adjust, suitable for couple intimacy and role-play experiences.\n\nOrder online from LushDesire with private and discreet shipping."
},
{
  id: "105",
  slug: "remote-control-automatic-dildo-for-women",
  name: "Remote Control Automatic Dildo",
  image: "/image/ForWomen/ForWomen5.jpg",
  price: "9999",
  mrp: "12999",
  category: "women",
  description:
    "Remote Control Automatic Dildo for women offering hands-free comfort and multiple stimulation modes. Wireless remote allows easy control from a distance.\n\nMade with premium, body-safe material for comfort, durability, and hygiene.\n\nBuy from LushDesire with discreet packaging and fast delivery across India."
},
{
  id: "106",
  slug: "bdsm-bed-kit-for-couples-india",
  name: "BDSM Bed Kit",
  image: "/image/ForWomen/ForWomen6.jpg",
  price: "3500",
  mrp: "3999",
  category: "women",
  description:
    "Premium BDSM Bed Kit for couples designed to enhance intimacy safely and comfortably. Includes high-quality accessories suitable for beginners and experienced couples.\n\nDurable materials with comfort-focused design ensure confidence during use.\n\nOrder online from LushDesire with discreet and secure delivery in India."
},
{
  id: "107",
  slug: "handcuff-set-for-couples-india",
  name: "Handcuff Set",
  image: "/image/ForWomen/ForWomen7.jpg",
  price: "2799",
  mrp: "4999",
  category: "women",
  description:
    "High-Quality Handcuff Set for couples designed for comfort, control, and durability. Soft inner lining ensures comfort during extended use.\n\nStrong build with easy locking mechanism for safety and confidence.\n\nAvailable at LushDesire with private packaging across India."
},
{
  id: "108",
  slug: "vibrating-dildo-for-women-india",
  name: "Vibrating Dildo",
  image: "/image/ForWomen/ForWomen8.jpg",
  price: "3999",
  mrp: "4999",
  category: "women",
  description:
    "Vibrating Dildo for women featuring powerful vibration modes and a silent motor. Designed for targeted stimulation and personalized pleasure.\n\nMade from body-safe material, easy to clean, and comfortable to use.\n\nBuy online from LushDesire with discreet delivery across India."
},
{
  id: "109",
  slug: "premium-vibrating-dildo-for-women",
  name: "Vibrating Dildo",
  image: "/image/ForWomen/ForWomen9.jpg",
  price: "2999",
  mrp: "3699",
  category: "women",
  description:
    "Premium Vibrating Dildo designed for comfort, smooth performance, and long-term use. Offers consistent vibration for enhanced pleasure.\n\nCompact design with body-safe material for hygiene and safety.\n\nOrder from LushDesire with private shipping in India."
},
{
  id: "110",
  slug: "luxury-butt-plug-for-women",
  name: "Butt Plug",
  image: "/image/ForWomen/ForWomen10.jpg",
  price: "2299",
  mrp: "2999",
  category: "women",
  description:
    "Luxury Butt Plug for women made with premium, body-safe material. Smooth and comfortable design ensures easy and safe use.\n\nSuitable for beginners and advanced users.\n\nAvailable online at LushDesire with discreet packaging across India."
},
{
  id: "111",
  slug: "g-spot-mini-rabbit-vibrator-india",
  name: "G-Spot Mini Rabbit Vibrator",
  image: "/image/ForWomen/ForWomen11.jpg",
  price: "5999",
  mrp: "6999",
  category: "women",
  description:
    "G-Spot Mini Rabbit Vibrator designed for dual stimulation with compact and ergonomic design. Targets G-spot and external pleasure simultaneously.\n\nMade with soft, body-safe material and multiple vibration modes for customized experience.\n\nBuy online from LushDesire with 100% discreet delivery across India."
},


  // for cuples 



    /* ================= COUPLES PRODUCTS ================= */

{
  id: "201",
  slug: "bdsm-kit-for-couples-india",
  name: "BDSM Kit for Couples",
  image: "/image/ForCouples/ForCouples1.jpg",
  price: "3500",
  mrp: "4600",
  category: "couples",
  description:
    "Buy BDSM Kit for couples in India designed to enhance intimacy, trust, and exploration in a safe and comfortable way. This premium kit includes high-quality bondage accessories crafted for durability and ease of use.\n\nPerfect for beginners as well as experienced couples, the kit focuses on comfort, adjustable fit, and body-safe materials.\n\nOrder online from LushDesire with 100% discreet packaging, secure payment options, and fast delivery across India."
},
{
  id: "202",
  slug: "bdsm-bondage-kit-for-couples",
  name: "BDSM Bondage Kit for Couples",
  image: "/image/ForCouples/ForCouples2.jpg",
  price: "3299",
  mrp: "4000",
  category: "couples",
  description:
    "BDSM Bondage Kit for couples designed to safely explore new levels of intimacy and connection. Made with premium-quality, body-safe materials for comfort and confidence.\n\nEasy to use and adjustable, making it suitable for couples at any experience level.\n\nBuy online from LushDesire with privacy-first packaging and trusted delivery across India."
},
{
  id: "203",
  slug: "belt-condom-for-couples-india",
  name: "Belt Condom for Couples",
  image: "/image/ForCouples/ForCouples3.jpg",
  price: "2499",
  mrp: "3500",
  category: "couples",
  description:
    "Belt Condom for couples in India designed for a secure fit, comfort, and confidence. Ideal for couples looking for enhanced control and protection.\n\nMade from body-safe materials with adjustable straps for ease of use.\n\nOrder online from LushDesire with discreet packaging and reliable delivery across India."
},
{
  id: "204",
  slug: "couples-belt-condom-secure-fit",
  name: "Couples Belt Condom – Secure Fit",
  image: "/image/ForCouples/ForCouples4.jpg",
  price: "2399",
  mrp: "3000",
  category: "couples",
  description:
    "Premium Couples Belt Condom designed with a secure and adjustable fit for comfort-focused use. Crafted from body-safe material for safety and durability.\n\nSuitable for couples seeking reliability and ease of use.\n\nBuy online from LushDesire with private and discreet shipping across India."
},
{
  id: "205",
  slug: "adjustable-belt-condom-for-couples",
  name: "Adjustable Belt Condom",
  image: "/image/ForCouples/ForCouples5.jpg",
  price: "2599",
  mrp: "4599",
  category: "couples",
  description:
    "Adjustable Belt Condom for couples designed for comfort, durability, and flexibility. Features easy adjustment for a personalized and secure fit.\n\nMade using body-safe materials suitable for repeated use.\n\nAvailable online at LushDesire with discreet delivery across India."
},
{
  id: "206",
  slug: "condoms-all-sizes-for-couples-india",
  name: "Condoms – All Sizes Available",
  image: "/image/ForCouples/ForCouples6.jpg",
  price: "1100",
  mrp: "2000",
  category: "couples",
  description:
    "Condoms for couples available in all sizes, from small to large, ensuring a comfortable and secure fit. Quality-tested for safety and reliability.\n\nIdeal for regular use with confidence and comfort.\n\nBuy online from LushDesire with safe, discreet packaging across India."
},
{
  id: "207",
  slug: "premium-condoms-for-couples",
  name: "Premium Condoms",
  image: "/image/ForCouples/ForCouples7.jpg",
  price: "1499",
  mrp: "2200",
  category: "couples",
  description:
    "Premium Condoms for couples designed to deliver comfort, protection, and peace of mind. Manufactured under strict quality standards.\n\nSmooth texture and reliable fit make them suitable for regular use.\n\nOrder online from LushDesire with discreet delivery across India."
},
{
  id: "208",
  slug: "condoms-for-perfect-fit-couples",
  name: "Condoms for Perfect Fit",
  image: "/image/ForCouples/ForCouples8.jpg",
  price: "1999",
  mrp: "2899",
  category: "couples",
  description:
    "Condoms for Perfect Fit designed for couples seeking comfort and confidence. Available in multiple sizes to ensure proper fit and safety.\n\nMade from quality-tested materials with a focus on reliability and hygiene.\n\nShop online at LushDesire with confidential shipping across India."
}





];



export default products;
